import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorBannerService } from '../services/error-banner.service';

@Injectable()
export class ErrorBannerInterceptor implements HttpInterceptor {
  constructor(private errorBannerService: ErrorBannerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Block all requests if service is down
    if (this.errorBannerService.isDown) {
      return EMPTY;
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Check for 502 Bad Gateway or other server errors
        if (
          error.status === 502 ||
          error.status === 503 ||
          error.status === 504 ||
          error.status === 0
        ) {
          this.errorBannerService.showServiceUnavailableBanner();
        }

        return throwError(error);
      }),
    );
  }
}
